<template>
  <el-input-number
    v-model="num"
    @change="debouncedMethod"
    class="custom-input-number"
    id="custom-input-number-1"
    :min="min"
    :step="step"
    :disabled="disabled"
    size="mini"
  ></el-input-number>
</template>
<script>
import { debounce } from "lodash";
export default {
  props: {
    modelValue: {
      type: Number | String,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    },
    minValue: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      num: 0,
      oldNum: 0
    };
  },
  watch: {
    modelValue: {
      handler(newV) {
        this.num = newV;
        this.oldNum = newV;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    changeNum() {
      if (this.num < this.minValue && this.minValue > 0) {
        this.$nextTick(() => {
          this.num = this.oldNum;
        });
        this.$emit("crearValue", 0);
      } else {
        this.$emit("change", this.num);
      }
    }
  },
  created() {
    this.debouncedMethod = debounce(this.changeNum, 500);
  },
  beforeDestroy() {
    this.debouncedMethod.cancel();
  }
};
</script>
<style>
#custom-input-number-1 {
  width: 80px;
  line-height: 22px;
  box-sizing: content-box !important;
  padding: 0 22px;
}
#custom-input-number-1 .el-input-number__increase,
#custom-input-number-1 .el-input-number__decrease {
  border-radius: 50%;
  background-color: rgb(232, 79, 71);
  color: #fff;
  font-weight: bolder;
  font-size: 12px;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#custom-input-number-1 .el-input-number__increase.is-disabled,
#custom-input-number-1 .el-input-number__decrease.is-disabled {
  background-color: #b9b9b9;
  display: none;
}
#custom-input-number-1 .el-input-number__increase i,
#custom-input-number-1 .el-input-number__decrease i {
  transform: scale(1) !important;
}
#custom-input-number-1 .el-input-number__decrease {
  left: 0px;
}
#custom-input-number-1 .el-input-number__increase {
  right: 0px;
}
#custom-input-number-1 .el-input__inner {
  padding-left: 0;
  padding-right: 0;
  height: 24px;
  font-size: 12px;
}
</style>
